import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDividerButton } from '../../hooks/notes/use_divider_button';
import { styled } from '../../styles';
import { IconButton } from '../buttons/icon_button';
import { toolbarButtonStyles } from './styles';
export const DividerButton = () => {
    const { onClick, isEnabled } = useDividerButton();
    return (_jsx(DividerWrapper, { children: _jsx(IconButton, { style: toolbarButtonStyles, iconName: "HorizontalRuleIcon", label: "HorizontalRuleButton", disabled: !isEnabled, onClick: onClick, "data-testid": "notes-divider-button" }) }));
};
const DividerWrapper = styled.div(function () {
    return {
        display: 'inline-block',
    };
});
//# sourceMappingURL=divider_button.js.map